import styled from "styled-components";

export const FigureText = styled.div`
  font-family: futura-pt, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 191.6%;
  letter-spacing: 0.04em;
  margin: 18px auto 25px auto;
`;
